import {app,rtdb,auth} from "../firebase";
import {getDatabase,ref,get,set,push,update} from "firebase/database"
import { createUser,updateUser } from "./UserService";
import { onAuthStateChanged } from "firebase/auth";

const companiesCollection = 'companies';

export const updatePricingCount = async (companyId,newPricingCount) => {
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");
  const db = getDatabase(app);
  const companyData = {
    pricingCount: newPricingCount
  };
  await update(ref(db, `companies/${companyId}`), companyData);
}

export const updateCompanyData = async (companyId,companyData) => {
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");
  // const db = getDatabase(app);
  // const companyData = {
  //   pricingCount: newPricingCount
  // };
  await update(ref(rtdb, `companies/${companyId}`), companyData);
}

export const saveCompanyData = async (companyId, data, currentUser) => {
  const db = getDatabase(app);
  const uid = currentUser?.uid;
  if (!uid) throw new Error("Usuário não autenticado.");

  const key = companyId || push(ref(db, companiesCollection)).key;

  let newUser = null;

  const userPayload = {
    companyId: key,
    firstLogin: false,
  };
  
  try {
    await updateUser(uid, userPayload); 
  } catch (e) {
    const baseUser = {
      uid,
      email: currentUser.email ?? "",
      name: currentUser.displayName ?? "",
      role: "master",
      permissions: [],
      createdAt: new Date().toISOString(),
      ...userPayload,
    };
    await createUser(uid, baseUser); 
    newUser = baseUser;
  }
  
  const companyData = removeUndefined({
    companyId: key,                    
    ownerUid: uid,                    
    plan: data.plan ?? "Free",
    pricingCount: data.pricingCount ?? 0,
    company: {
      name: data.name,
      address: data.address,
      phone: data.phone,
      mission: data.mission,
      vision: data.vision,
      values: data.values,
      rules: data.rules,
      tempoSemanal: data.tempoSemanal,
      createdAt: new Date().toISOString(),
    },
    employee: Array.isArray(data.funcionarios) ? data.funcionarios : [],
    fixedCosts: Array.isArray(data.custosFixos) ? data.custosFixos : [],
    variableCosts: Array.isArray(data.custosVariaveis) ? data.custosVariaveis : [],
  });
  
  await set(ref(db, `companies/${key}`), companyData); 
  
  const finalUser = newUser
    ? newUser
    : { ...(currentUser || {}), ...userPayload }; 

  return { company: companyData, user: finalUser };
};

export async function createNewCompany(uid) {
  const compRef = push(ref(rtdb, companiesCollection));
  await set(compRef, { ownerUid: uid, createdAt: new Date().toISOString() });
  return compRef.key;
}

function removeUndefined(obj) {
  return JSON.parse(JSON.stringify(obj));
}


export const findCompany = async (companyId) => {
  try {
    const db = getDatabase(app);
    const userRef = ref(db, `companies/${companyId}`);
    const snapshot = await get(userRef);

    if (snapshot.exists()) {
      return snapshot.val(); 
    } else {
      return null;
    }
  } catch (error) {
    throw error; 
  }
};

export const findCompanySafe = async () => {
  // espera estar autenticado
  const user = await new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (u) => { unsub(); resolve(u); });
  });
  if (!user) throw new Error("Usuário não autenticado");

  const db = getDatabase(app);
  // lê o companyId do usuário primeiro (garante que a regra vai permitir depois)
  const userSnap = await get(ref(db, `users/${user.uid}/companyId`));
  if (!userSnap.exists()) throw new Error("Usuário sem companyId vinculado");

  const companyId = userSnap.val();
  const snap = await get(ref(db, `companies/${companyId}`));
  return snap.exists() ? snap.val() : null;
};

export const getCompanyData = async (companyId) => {
  return findCompany(companyId);
};


